import { TableName } from './tableName.enum';

export const EventFunctions = {
  [TableName.Club]: 'clubEvents',
  [TableName.Team]: 'teamEvents',
  [TableName.User]: 'userEvents'
};
